import React from "react"
import PropTypes from "prop-types"

import SEO from "../seo"
import Navbar from "../Navbar/Navbar"
import Footer from "../Footer/Footer"

const SimpleLayout = ({ children, path }) => (
  <>
    <SEO />
    <Navbar path={path}/>
    {children}
    <Footer />
  </>
)

SimpleLayout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default SimpleLayout
